/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Go_To_SlideInputs */

const en_go_to_slide = /** @type {(inputs: Go_To_SlideInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Go to slide ${i?.index}`)
};

const fr_go_to_slide = /** @type {(inputs: Go_To_SlideInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aller à la diapositive ${i?.index}`)
};

const de_go_to_slide = /** @type {(inputs: Go_To_SlideInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gehen Sie zu Folie ${i?.index}`)
};

const it_go_to_slide = /** @type {(inputs: Go_To_SlideInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vai alla diapositiva ${i?.index}`)
};

const ru_go_to_slide = /** @type {(inputs: Go_To_SlideInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Перейти к слайду ${i?.index}`)
};

const es_go_to_slide = /** @type {(inputs: Go_To_SlideInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ir a la diapositiva ${i?.index}`)
};

const zh_cn2_go_to_slide = /** @type {(inputs: Go_To_SlideInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`转到幻灯片${i?.index}`)
};

const ja_go_to_slide = /** @type {(inputs: Go_To_SlideInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`スライドへ移動 ${i?.index}`)
};

const hi_go_to_slide = /** @type {(inputs: Go_To_SlideInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्लाइड ${i?.index} पर जाएं`)
};

const pt_pt2_go_to_slide = /** @type {(inputs: Go_To_SlideInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vá para o slide ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Go to slide {index}" |
*
* @param {Go_To_SlideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const go_to_slide = /** @type {((inputs: Go_To_SlideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_To_SlideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_go_to_slide(inputs)
	if (locale === "de") return de_go_to_slide(inputs)
	if (locale === "it") return it_go_to_slide(inputs)
	if (locale === "ru") return ru_go_to_slide(inputs)
	if (locale === "es") return es_go_to_slide(inputs)
	if (locale === "zh-CN") return zh_cn2_go_to_slide(inputs)
	if (locale === "ja") return ja_go_to_slide(inputs)
	if (locale === "hi") return hi_go_to_slide(inputs)
	if (locale === "pt-PT") return pt_pt2_go_to_slide(inputs)
	return en_go_to_slide(inputs)
});